import { AxiosRequestConfig } from 'axios';
import { RetrievalPayload } from '../types/data-profiling.type';

const endpoint = '/data-retrieval';

export default {
    getMongoData: (data: RetrievalPayload) =>
        ({ method: 'POST', url: `${endpoint}/retrieval/mongo`, data } as AxiosRequestConfig),
};
